/**
 * Simple UUID v4 generator for submission IDs
 * Used to ensure idempotent webhook submissions
 */
export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  });
};

/**
 * Generate a submission-specific UUID that includes timestamp
 * Format: submission_TIMESTAMP_UUID
 */
export const generateSubmissionId = () => {
  const timestamp = Date.now();
  const uuid = generateUUID();
  return `submission_${timestamp}_${uuid}`;
};

